import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';

const LoadingSpinner = ({ color = '#ff8761' }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      position: 'fixed', // Ensures it covers the viewport
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.7)', // Explicitly set transparent
      zIndex: 9999 // Ensure it appears above other content
    }}
  >
    <CircularProgress sx={{ color }} />
  </Box>
);

LoadingSpinner.propTypes = {
  color: PropTypes.string,
};

export default LoadingSpinner;